import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const publishManifest: FeatureManifest = {
  id: 'publish',
  path: 'publish/*',
  navPath: '/publish',
  label: 'Xuất bản',
  description: 'Quản lý dữ liệu đã xuất bản',
  load: () => import('./entry'),
}
